<cui-button class="btn_style_sm" (click)="enviarReforzamiento()">Generar Reforzamiento Online</cui-button>

<long-wait-loading-modal>
    <div #messageElement ngProjectAs="message">
        {{ message }}
    </div>

    <div #errorMessageElement ngProjectAs="errorMessage">Ha ocurrido un error. Por favor intente más tarde.</div>
</long-wait-loading-modal>
